// Stringhe UI in italiano. Struttura predisposta per futura internazionalizzazione (es. en.js).

export const ROLE_LABELS = {
  SUPER_ADMIN: "Super Admin",
  CONSULENTE: "Consulente",
  ADMIN_AZIENDA: "Admin Azienda",
  ESG_MANAGER: "ESG Manager",
  HR_MANAGER: "HR Manager",
  DATA_ENTRY: "Data Entry",
  VIEWER: "Viewer",
};

export const PERIOD_STATUS = {
  DRAFT: { label: "Bozza" },
  IN_PROGRESS: { label: "In corso" },
  IN_REVIEW: { label: "In revisione" },
  APPROVED: { label: "Approvato" },
  LOCKED: { label: "Bloccato" },
};

export const SIZE_LABELS = {
  MICRO: "Microimpresa",
  PICCOLA: "Piccola impresa",
  MEDIA: "Media impresa",
  NON_PMI: "Non PMI",
};

export const NAV_SECTIONS = [
  {
    group: "PANORAMICA",
    items: [
      { path: "/dashboard", label: "Dashboard", icon: "LayoutDashboard", testid: "nav-dashboard" },
      { path: "/portafoglio", label: "Portafoglio clienti", icon: "Users2", testid: "nav-portafoglio", perm: "analysis:score:view" },
      { path: "/note-interne", label: "Note interne", icon: "FileText", testid: "nav-note-interne", perm: "analysis:notes:view" },
    ],
  },
  {
    group: "IL MIO ESG",
    items: [
      { path: "/esg", label: "Environmental · Social · Governance", icon: "Leaf", testid: "nav-esg" },
      { path: "/percorso", label: "Percorso guidato", icon: "Compass", testid: "nav-percorso", perm: "esg:read" },
      { path: "/questionario", label: "Questionario ESG", icon: "ClipboardList", testid: "nav-questionario" },
      { path: "/environmental", label: "Environmental Engine", icon: "Zap", testid: "nav-environmental" },
      { path: "/social", label: "Social Engine", icon: "Users2", testid: "nav-social" },
      { path: "/governance", label: "Governance Engine", icon: "Scale", testid: "nav-governance" },
      { path: "/eva", label: "Eva — ESG Assistant", icon: "Sparkles", testid: "nav-eva" },
      { path: "/vsme", label: "VSME", icon: "ClipboardCheck", testid: "nav-vsme" },
      { path: "/documenti", label: "Documenti", icon: "FileText", testid: "nav-documenti" },
      { path: "/jobtimehr", label: "JOBTIMEHR", icon: "Link2", testid: "nav-jobtimehr" },
    ],
  },
  {
    group: "PIANIFICAZIONE",
    items: [
      { path: "/piano-miglioramento", label: "Piano di miglioramento", icon: "TrendingUp", testid: "nav-piano", perm: "analysis:plan:view" },
      { path: "/obiettivi", label: "Obiettivi", icon: "Target", testid: "nav-obiettivi", perm: "analysis:plan:view" },
      { path: "/simulazioni", label: "Simulazioni", icon: "SlidersHorizontal", testid: "nav-simulazioni", perm: "analysis:simulation:run" },
      { path: "/questionari-esterni", label: "Questionari esterni", icon: "HelpCircle", testid: "nav-questionari", perm: "esg:read" },
      { path: "/data-room-interna", label: "Data Room", icon: "FolderLock", testid: "nav-dataroom", perm: "dataroom:view" },
    ],
  },
  {
    group: "REPORTING & AUDIT",
    items: [
      { path: "/valutazione", label: "Valutazione ESG", icon: "Scale", testid: "nav-valutazione", perm: "analysis:score:view" },
      { path: "/report", label: "Report", icon: "BarChart3", testid: "nav-report", perm: "analysis:report:view" },
      { path: "/pmi-banche", label: "Dossier PMI-Banche", icon: "Landmark", testid: "nav-pmi-banche", perm: "analysis:dossier:view" },
      { path: "/audit-log", label: "Registro attività", icon: "History", testid: "nav-audit-log" },
    ],
  },
  {
    group: "GESTIONE AZIENDALE",
    items: [
      { path: "/azienda", label: "Anagrafica Azienda", icon: "Building2", testid: "nav-azienda" },
      { path: "/onboarding", label: "Onboarding & Autofill", icon: "Sparkles", testid: "nav-onboarding" },
      { path: "/utenti", label: "Utenti e Ruoli", icon: "UserCheck", testid: "nav-utenti" },
      { path: "/periodi", label: "Periodi di rendicontazione", icon: "CalendarRange", testid: "nav-periodi" },
      { path: "/impostazioni", label: "Impostazioni", icon: "Settings", testid: "nav-impostazioni" },
    ],
  },
];

export const SUBMISSION_STATUS = {
  DRAFT: { label: "Bozza — non inviata", cls: "bg-slate-100 text-slate-700" },
  SUBMITTED_BY_COMPANY: { label: "Inviata al consulente", cls: "bg-sky-100 text-sky-800" },
  UNDER_CONSULTANT_REVIEW: { label: "In revisione dal consulente", cls: "bg-amber-100 text-amber-800" },
  RETURNED_FOR_CORRECTION: { label: "Restituita per integrazioni", cls: "bg-red-100 text-red-800" },
  ACCEPTED_FOR_ANALYSIS: { label: "Accettata per l'analisi", cls: "bg-green-100 text-green-800" },
  INTEGRATION_REQUIRED: { label: "Da integrare", cls: "bg-red-100 text-red-800" },
  READY_FOR_RESUBMISSION: { label: "Pronto per nuovo invio", cls: "bg-amber-100 text-amber-800" },
  APPROVED_BY_CONSULTANT: { label: "Approvato dal consulente", cls: "bg-emerald-100 text-emerald-800" },
  SENT_TO_BANK: { label: "Inviato alla banca", cls: "bg-indigo-100 text-indigo-800" },
};

// Stati univoci della risposta (FASE 6): etichette italiane per l'utente.
// Una risposta può essere compilata al 100% ma non ancora verificata o approvata.
export const ANSWER_STATE_LABELS = {
  MANCANTE: { label: "Mancante", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  VALIDO: { label: "Valido", cls: "bg-green-100 text-green-800 border-green-300" },
  AVVISO: { label: "Avviso", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  INCOERENTE: { label: "Incoerente", cls: "bg-red-100 text-red-800 border-red-300" },
  DA_VERIFICARE: { label: "Da verificare", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  VERIFICATA: { label: "Verificata", cls: "bg-green-100 text-green-800 border-green-300" },
  APPROVATA: { label: "Approvata", cls: "bg-green-700 text-white border-green-700" },
  NON_APPLICABILE: { label: "Non applicabile", cls: "bg-slate-50 text-slate-500 border-slate-200" },
};

// Stati univoci del questionario (FASE 6), derivati dal backend
// (questionnaire_state nell'endpoint /questionnaire/progress).
export const QUESTIONNAIRE_STATE_LABELS = {
  DA_INIZIARE: { label: "Da iniziare", cls: "bg-slate-100 text-slate-700" },
  IN_COMPILAZIONE: { label: "In compilazione", cls: "bg-sky-100 text-sky-800" },
  COMPLETO_DA_INVIARE: { label: "Completo — da inviare al consulente", cls: "bg-amber-100 text-amber-800" },
  INVIATO_AL_CONSULENTE: { label: "Inviato al consulente", cls: "bg-sky-100 text-sky-800" },
  IN_REVISIONE: { label: "In revisione dal consulente", cls: "bg-amber-100 text-amber-800" },
  RICHIESTA_INTEGRAZIONE: { label: "Integrazione richiesta dal consulente", cls: "bg-red-100 text-red-800" },
  ACCETTATO_PER_ANALISI: { label: "Accettato per l'analisi", cls: "bg-green-100 text-green-800" },
  APPROVATO: { label: "Approvato", cls: "bg-green-700 text-white" },
  RIAPERTO: { label: "Riaperto per modifiche", cls: "bg-amber-100 text-amber-800" },
  DA_INTEGRARE: { label: "Da integrare", cls: "bg-red-100 text-red-800" },
  PRONTO_PER_NUOVO_INVIO: { label: "Pronto per nuovo invio", cls: "bg-amber-100 text-amber-800" },
  DA_RIESAMINARE_INTEGRAZIONE_NECESSARIA: { label: "Da integrare", cls: "bg-red-100 text-red-800" },
  APPROVATO_DAL_CONSULENTE: { label: "Approvato dal consulente", cls: "bg-emerald-100 text-emerald-800" },
  INVIATO_ALLA_BANCA: { label: "Inviato alla banca", cls: "bg-indigo-100 text-indigo-800" },
};

// Normalizzazione SOLO visuale del nome utente (FASE 13): rimuove spazi
// iniziali/finali e riduce gli spazi multipli interni a uno. Non modifica mai
// il dato memorizzato, non unisce nome e cognome, non altera accenti o apostrofi.
export function formatDisplayName(name) {
  if (!name) return "";
  return String(name).trim().replace(/\s+/g, " ");
}

export const VALUE_STATUS = {
  MISSING: { label: "Mancante", className: "bg-slate-100 text-slate-700 border-slate-300" },
  DRAFT: { label: "Bozza", className: "bg-slate-100 text-slate-700 border-slate-300" },
  IMPORTED: { label: "Importato", className: "bg-sky-100 text-sky-800 border-sky-300" },
  TO_VERIFY: { label: "Da verificare", className: "bg-amber-100 text-amber-800 border-amber-300" },
  VERIFIED: { label: "Verificato", className: "bg-green-100 text-green-800 border-green-300" },
  APPROVED: { label: "Approvato", className: "bg-green-700 text-white border-green-700" },
  ESTIMATED: { label: "Stimato", className: "bg-indigo-100 text-indigo-800 border-indigo-300" },
  NOT_APPLICABLE: { label: "Non applicabile", className: "bg-slate-50 text-slate-500 border-slate-200" },
  OMITTED_SENSITIVE: { label: "Omesso (sensibile)", className: "bg-purple-100 text-purple-800 border-purple-300" },
};

export const APPLICABILITY_LABELS = {
  APPLICABLE: "Applicabile",
  NOT_APPLICABLE: "Non applicabile",
  TO_BE_DETERMINED: "Da determinare",
};

export const SOURCE_TYPE_LABELS = {
  MANUAL: "Inserimento manuale",
  DOCUMENT: "Documento",
  JOBTIMEHR: "JOBTIMEHR",
  EXCEL_IMPORT: "Importazione Excel",
  CSV_IMPORT: "Importazione CSV",
  API: "API esterna",
  ACCOUNTING_SYSTEM: "Sistema contabile",
  ENERGY_PROVIDER: "Fornitore energia",
  CALCULATED: "Calcolato",
  JOBTIMEHR: "JOBTIMEHR",
  JOBTIMEHR_MOCK: "JOBTIMEHR — MOCK",
  PAYROLL: "Payroll",
  EXTERNAL_SYSTEM: "Sistema esterno",
  AI_EXTRACTION: "Estrazione AI",
  CONSULTANT: "Consulente",
  ESTIMATE: "Stima",
  OTHER: "Altro",
};

export const CATEGORY_LABELS = {
  GENERAL: "Informazioni generali",
  ENVIRONMENTAL: "Environmental",
  SOCIAL: "Social",
  GOVERNANCE: "Governance",
};

export const CATEGORY_STYLES = {
  GENERAL: "bg-slate-100 text-slate-700 border-slate-300",
  ENVIRONMENTAL: "bg-green-100 text-green-800 border-green-300",
  SOCIAL: "bg-sky-100 text-sky-800 border-sky-300",
  GOVERNANCE: "bg-indigo-100 text-indigo-800 border-indigo-300",
};

export const MODULE_LABELS = {
  BASIC: "Basic Module",
  COMPREHENSIVE: "Comprehensive Module",
};

export const COMMON = {
  appName: "ESG-PMI",
  loading: "Caricamento in corso…",
  save: "Salva",
  cancel: "Annulla",
  create: "Crea",
  delete: "Elimina",
  edit: "Modifica",
  comingSoon: "COMING SOON",
  demo: "DEMO",
  noData: "DATI NON ANCORA DISPONIBILI",
};

// Ruoli di assegnazione del consulente su un'azienda cliente (etichette italiane).
export const ASSIGNMENT_ROLE_LABELS = {
  LEAD_CONSULTANT: "Consulente responsabile",
  CONSULTANT: "Consulente",
  REVIEWER: "Revisore",
  SPECIALIST: "Specialista",
  READ_ONLY: "Sola lettura",
};
export const assignmentRoleLabel = (r) => ASSIGNMENT_ROLE_LABELS[r] || r;
